
// export class SgfCredito {
//     cod_producto: number;
//     cod_cuenta: number;
//     nom_destino: string;
//     valCapital: number;
//     numCuotas: number;
//     valTasaInteres: number;
//     fecPrestamo: Date;
//     fechapagar: Date;
//     fecVencimiento: Date;
//     cfValSaldo: number;
//     numDiasMora: number;
//     valorpagar: number;
//     numPlazo: number;
//     CodCuentaSocio: number;
//     stsPrestamo: string;

//     /**
//      * Constructor
//      *
//      * @param contact
//      */
//     constructor(contact)
//     {
//         {

//         }
//     }
// }


export class SocioCredito {
    codProducto: number;
    codCuenta: number;
    nomTipoCredito: string;
    valCapital: number;
    numCuotas: number;
    valTasaInteres: number;
    fecPrestamo: Date;
    fecVencimiento: Date;
    cfValSaldo: number;
    numDiasMora: number;
}


export class SocioTablaCredito {
    numCuota: number;
    valCapital: number;
    valInteres: number;
    valSaldoMora: number;
    seguro: number;
    fecVencimiento: Date;
    estado: string;

}
export class Solicitudcredito {
    token: string;
    nomSocio: string;
    numId: string;
    dirDom: string;
    cta: string;
    fsolicitud: string;
    clasifcredito: string;
    tipocredito: string;
    valTasaMax: string;
    valDeseado: string;
    plazoDias: string;
    numCuotas: string;
    tipoCuota: string;
    totalInteres: string;
    totalCapital: string;
    fvencimiento: string;
    fecVencimineto: string;
    totalPlazo: string;
    archivo: string; //Base64
    txtCanton: string;
}
export class SolCredito {
    id: {
        codProducto: string;
        codCuenta: string;
    };
    codProductoSocio: string;
}

export class SolicitudCreditoTabla {
    // token: string;
    // cta: number;
    // numCuota: number;
    // valCapital: number;
    // valIteres: number;
    // valTasaInteres: number;
    // fInicio: string;
    // fVencimiento: string;
    // valSeguro: number;
    // valSaldoCapital: number;

    id: {
        codProducto: number;
        codCuenta: number;
        numCuota: number;
    };
    valCapital: number;
    valInteres: number;
    valTasaInteres: number;
    fecInicio: string;
    fecVencimiento: string;
    txtReferencia: string;
    valSeguro: number;
    valSaldoCapital: number;
}
